import { getMerchantDetails } from "../pages/Settings/settingsSlice";

export const getMerchantBusinessDetails = async (
  dispatch,
  userId,
  updateBusinessObj,
) => {
  const merchantDetails = await dispatch(getMerchantDetails(userId));

  if (getMerchantDetails.fulfilled.match(merchantDetails)) {
    const hasBusiness = merchantDetails?.payload.find((data) => data.enabled);
    if (hasBusiness) {
      dispatch(updateBusinessObj(hasBusiness));
    }
  }
};
